var Core = {
    computed : {
        freeProductPrice : window.Laravel.data.free_product_price,

        count(){
            return Object.keys(this.basket).length;
        },
        baseTotalPrice(){
            var price = 0;

            //Items from basket
            for ( var key in this.basket )
                price += this.itemPrice(this.basket[key]) * this.basket[key].quantity;

            return price;
        },
        totalPrice(){
            var price = this.baseTotalPrice;

            for ( var key in this.freeProducts )
                price += Core.computed.freeProductPrice;

            return price + this.getAdditionalPrice;
        },
        totalPriceWithoutAdditional(){
            var price = this.totalPrice - this.getAdditionalPrice;

            return price;
        },
        totalPriceWithoutTax(){
            var price = 0,
                product_total;

            //Items from basket
            for ( var key in this.basket ){
                product_total = (this.itemPrice(this.basket[key]) * this.basket[key].quantity) / (1 + (this.basket[key].product.vat / 100));

                //Round prices to 2 decimal
                price += Math.round(product_total * 100) / 100;
            }

           for ( var key in this.freeProducts ){
                price += Core.computed.freeProductPrice / (1 + (this.freeProducts[key].vat / 100));
           }

            return price + this.getAdditionalPriceWithoutTax;
        },
        totalPriceProfitable(){
            var price = 0;

            for ( var key in this.basket )
            {
                var product = this.basket[key].product;

                //Add profitable price, if product does not have profitable category
                if ( _.filter(product.subcategories, { nonprofits : true }).length == 0 )
                    price += this.itemPrice(this.basket[key]) * this.basket[key].quantity;
            }

            return price - parseFloat(this.couponPrice);
        },
        totalPriceWithDiscount(){
            return (this.totalPrice - parseFloat(this.couponPrice) - parseFloat(this.discountPrice)).toFixed(2);
        },
        totalPriceProfitableWithDiscount(){
            return (this.totalPriceProfitable - parseFloat(this.discountPrice)).toFixed(2);
        },
        totalPriceWithoutTaxAndDiscount(){
            var copoun_without_tax = (parseFloat(this.couponPrice) / (1 + (window.Laravel.data.vat / 100))),
                discount_without_tax = (parseFloat(this.discountPrice) / (1 + (window.Laravel.data.vat / 100)));

            return (this.totalPriceWithoutTax - copoun_without_tax - discount_without_tax).toFixed(2);
        },
        getAdditionalPrice(){
            var price = 0;

            //Bottles and boxes
            for ( var key in this.getAdditional )
                price += this.getAdditional[key].price * this.getAdditional[key].quantity;

            return price;
        },
        getAdditionalPriceWithoutTax(){
            var price = 0;

            //Bottles and boxes
            for ( var key in this.getAdditional )
                price += (this.getAdditional[key].price * this.getAdditional[key].quantity) / (1 + (this.getAdditional[key].vat / 100));

            return price;
        },
        hasCouponProductInBasket(){
            if ( ! this.cupoun || ! this.cupoun.product )
                return false;

            for ( var key in this.basket )
            {
                if ( this.basket[key].product.id == this.cupoun.product.id )
                    return true;
            }

            return false;
        },
        couponPrice(){
            var price = 0;

            //If no cupoun is selected
            if ( ! this.cupoun )
                return 0;

            //Rule for minimum order price
            if ( this.cupoun.price_limit > 0 && this.baseTotalPrice < this.cupoun.price_limit )
                return 0;

            for ( var key in this.basket )
            {
                //Rule for specific product
                if ( this.cupoun.product && this.basket[key].product.id == this.cupoun.product.id )
                {
                    if ( this.cupoun.discount_percent > 0 )
                        price += (this.itemPrice(this.basket[key]) * this.basket[key].quantity) / 100 * this.cupoun.discount_percent;

                    else if ( this.cupoun.discount_price > 0 )
                        price += this.cupoun.discount_price;

                    break;
                }
            }

            //If is cupoun without product, just calculate from whole order
            if ( ! this.cupoun.product )
            {
                if ( this.cupoun.discount_percent > 0 )
                    price += parseFloat(this.baseTotalPrice) / 100 * this.cupoun.discount_percent;

                else if ( this.cupoun.discount_price > 0 )
                    price += this.cupoun.discount_price;
            }

            return price.toFixed(2);
        },
        discountPrice(){
            var price = 0,
                delivery = this.getSelectedDelivery,
                discount_percent = delivery ? delivery.contractor_discount : 0;

                if ( this.isContractor && discount_percent > 0 )
                    price += parseFloat(this.totalPriceWithoutAdditional) / 100 * discount_percent;

            return price.toFixed(2);
        },
        freeProducts(){
            var free_products = window.Laravel.data.free_products,
                profitable = this.totalPriceProfitable;

            return free_products.filter(item => {
                if ( item.free_from > 0 && item.free_from < profitable )
                    return true;

                return false;
            })
        },
        getAdditional(){
            var items = {},
                basket = _.cloneDeep(this.basket);

            for ( var key in basket )
            {
                var bottle_id = basket[key].product.bottle_id,
                    box_id = basket[key].product.box_id;

                //Add bottle
                if ( bottle_id && basket[key].product.bottle ) {
                    if ( !(bottle_id in items) ){
                        basket[key].product.bottle.quantity = basket[key].quantity;

                        items[bottle_id] = basket[key].product.bottle;
                    } else {
                        items[bottle_id].quantity += parseInt(basket[key].quantity);
                    }
                }

                //Add box
                if ( box_id && this.isContractor && basket[key].product.box ) {
                    if ( !(box_id in items) ){
                        basket[key].product.box.quantity = basket[key].quantity;
                        basket[key].product.box.is_box = true;

                        items[box_id] = basket[key].product.box;
                    } else {
                        items[box_id].quantity += parseInt(basket[key].quantity);
                    }
                }
            }

            for ( var key in items ) {
                if ( items[key].is_box === true ) {
                    items[key].quantity = Math.ceil(items[key].quantity / (items[key].box_size||1));
                }
            }

            return items;
        },
        isContractor(){
            return this.$root.client.type == 'contractor';
        },
    },

    methods : {
        itemPrice(item){
            let price = parseFloat(item.product.price),
                additionalPrice = 0;

            //Add additional price from additional variants
            if ( item.variants && typeof item.variants == 'object') {
                for ( var key in item.variants ) {
                    for ( var k in item.variants[key] ) {
                        let variant = item.variants[key][k];

                        if ( variant.product ) {
                            additionalPrice += parseFloat(variant.product.price);
                        }
                    }
                }
            }

            return price + additionalPrice;
        },
        checkCode(code, first){
            if ( first == true && !code )
                return;

            $.post(window.Laravel.requests.basket.update_code, { code : code }, function(response){
                if ( typeof response == 'object' )
                {
                    if ( 'success' in response )
                    {
                        this.cupoun = response.code;
                        return this.code_status = true;
                    }

                    if ( first !== true )
                        window.ajaxResponse(response);
                }

                this.cupoun = null;
                this.code_status = false;
            }.bind(this));
        },
        hasProductNotEnoughtQty(product){
            var qty = 0;

            for ( var key in this.basket )
            {
                if ( this.basket[key].product.id == product.id )
                {
                    qty += this.basket[key].quantity;
                }
            }

            return product.quantity < qty;
        },
        toPrice(price){
            return parseFloat(price).formatMoney();
        },
        getVariants(variants){
            var items = [];

            for ( var key in variants ) {
                Object.keys(variants[key]).forEach(id => {
                    items.push( variants[key][id] )
                })
            }

            return items;
        },
        removeItem(id){
            Vue.delete( this.$root.basket, id );

            $.get(window.Laravel.requests.basket.delete, { item_id : id }, function(response){
                this.$root.basket = response;
            }.bind(this));
        },
        getProductAction(product){
            return window.Laravel.requests.product.replace(':id', product.id).replace(':slug', product.slug);
        },
    }
}

export default Core;